import { requestLaunchExternalLink, setBreadcrumb } from "painel/actions";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getServiceName } from "shared/helper/serviceLauncher";
import { verificarPadraoUrl } from "shared/helper/utilitarioUrl";
import history from "../../../history";
import itensFixos from "../../../painel/component/drawer/menu.json";
import { removeBarrasIniciais } from "../newdashboard/servicos";
import './breadcrumb.css';

const ETAPAS_NOVO_PEDIDO_BI = [
    { path: '/requerimentos/iniciar/informativo', useTituloPagina: true, label: 'Informação do Benefício' },
    { path: '/requerimentos/onboarding', useTituloPagina: true, label: "Beneficio por incapacidade" },
    { path: '/requerimentos/contato', label: 'Contatos' },
    { path: '/requerimentos/dados', label: 'Dados do pedido' },
    { path: '/requerimentos/vinculos', label: 'Trabalhos e Contribuições' },
    { path: '/requerimentos/disponibilidade', label: 'Agência do INSS e Local de Pagamento' },
    { path: '/requerimentos/orgaopagador', label: 'Orgão pagador' },
    { path: '/requerimentos/concluir', label: 'Confirmação do Pedido' }
];

const ETAPAS_DETALHAR_PEDIDO = [
    { path: '/requerimentos/detalhar', label: 'Detalhar Pedido' },
];

const ETAPAS_PRORROGAR_PEDIDO_BI = [
    { path: '/requerimentos/iniciar/informativo', useTituloPagina: true, label: 'Informação do Benefício' },
    { path: '/requerimentos/prorrogar', useTituloPagina: true, label: 'Prorrogar Benefício por Incapacidade' },
];

const ETAPAS_CONVERTER_PEDIDO = [
    { path: '/requerimentos/converter', label: 'Converter Perícia Presencial em Análise Documental' },
];

const Breadcrumb = () => {

    const dispatch = useDispatch();

    const crumbAutofocus = useRef(null);

    const dicionarioPaths = useSelector(state => state.app.dicionarioPaths);

    const padroesDePath = useSelector(state => state.app.padroesDePath);

    const servicoSelecionado = useSelector(state => state.requerimentos.onboarding.requerimentoTO.servicoSelecionado);

    const parent = useSelector(state => state.app.breadcrumb.parent);

    const breadcrumbPath = useSelector(state => state.app.breadcrumb.caminho);

    const enabled = useSelector(state => state.app.breadcrumb.enabled);

    const menuMeuInssGestao = useSelector(state => state.app.menuItems);

    const [breadcrumbPaths, setBreadcrumbPaths] = useState([]);

    const menuItems = useMemo(() => {
        if (menuMeuInssGestao == null || menuMeuInssGestao.length == 0) {
            return itensFixos;
        }
        return menuMeuInssGestao;
    }, [menuMeuInssGestao]);

    const handleLinkClick = useCallback((event) => {
        const target = event.target.closest('a');
        if (!target) return; // Ignorar se não for um link

         if (target.closest('.br-skiplink')) {
            return;
        }

        if (target.href) {
            const url = new URL(target.href);
            // Verifica se é um URL Blob
            const isBlobURL = url.protocol === "blob:";
            if (isBlobURL) {
                // Permitir a ação padrão para URLs Blob
                return;
            }
            const isExternal = url.origin !== window.location.origin;
            if (isExternal) {
                event.preventDefault();
                dispatch(requestLaunchExternalLink(target.href));
                return;
            }
            // Evitar navegação padrão para URLs internas
            event.preventDefault();
            history.push(url.hash.replace("#/", "/"));
        }
    }, [history]);

    useEffect(() => {

        document.addEventListener('click', handleLinkClick);

        prependParent();

        return () => {
            document.removeEventListener('click', handleLinkClick);
        };

    }, [menuItems, breadcrumbPath]);

    useEffect(() => {
        breadcrumbPathFactory();
    }, [menuItems, dicionarioPaths, parent, enabled]);

    function breadcrumbPathFactory() {
        if (menuItems && menuItems.length > 0) {
            let pathname = window.location.hash.replace("#/", "/").replace("//", "/").split("?")[0];

            if (ETAPAS_NOVO_PEDIDO_BI.some(p => pathname.startsWith(p.path))) {
                let caminho = ETAPAS_NOVO_PEDIDO_BI.slice(0, 1);
                dispatch(setBreadcrumb({ parent: "/grupo/beneficios-incapacidade", caminho }));
            } else if (ETAPAS_PRORROGAR_PEDIDO_BI.some(p => pathname.startsWith(p.path))) {
                let caminho = ETAPAS_PRORROGAR_PEDIDO_BI.slice(0, 1);
                dispatch(setBreadcrumb({ parent: "/grupo/beneficios-incapacidade", caminho }));
            } else if (ETAPAS_CONVERTER_PEDIDO.some(p => pathname.startsWith(p.path))) {
                let caminho = [...ETAPAS_DETALHAR_PEDIDO, ...ETAPAS_CONVERTER_PEDIDO].slice(0, 1);
                dispatch(setBreadcrumb({ parent: '/requerimentos', caminho, enabled }));
            } else {
                let breadcrumbPathBypathname = buildBreadcrumbPathByPathname(pathname);
                dispatch(setBreadcrumb({ parent, caminho: breadcrumbPathBypathname, enabled }))
            }
        }
    }

    function prependParent() {
        if (menuItems && menuItems.length > 0) {

            let caminhoRaiz = [];
            let parentAsArray = parent && !Array.isArray(parent) ? [parent] : parent;
            if (Array.isArray(parentAsArray)) {
                parentAsArray.forEach(currentParent => {
                    let currentCaminho = buildBreadcrumbPathByPathname(currentParent);
                    if (currentCaminho) {
                        caminhoRaiz = [...caminhoRaiz, ...currentCaminho];
                    }
                })
            }
            if (Array.isArray(caminhoRaiz) && caminhoRaiz.length > 0) {
                if (!enabled || !Array.isArray(breadcrumbPath)) {
                    setBreadcrumbPaths(([...caminhoRaiz]) || []);
                } else {
                    setBreadcrumbPaths(([...caminhoRaiz, ...breadcrumbPath]) || []);
                }
            } else {
                setBreadcrumbPaths(Array.isArray(breadcrumbPath) ? breadcrumbPath : []);
            }
        }
    }

    function buildBreadcrumbPathByPathname(pathname) {
        let tree = [...menuItems].slice(1); //Sem Destaques
        let caminho = findPathByChave(tree, pathname);
        if (caminho == null || caminho.length == 0) {
            caminho = findPathByChave([[...menuItems][0]], pathname); //consulta nos destaques
        }

        if (caminho == null || caminho.label == 0) {
            caminho = findPathByChave(itensFixos, pathname); //Procura dos menu.json
        }

        if (!Array.isArray(caminho) || caminho?.length == 0) {
            let pageName = dicionarioPaths[pathname];
            if (pageName) {
                caminho = [{ path: pathname, titulo: pageName }];
            } else {
                let padrao = verificaSeUrlCorrespondeAosPadroesSalvos(pathname);
                let pageName = padrao && dicionarioPaths[padrao] ? dicionarioPaths[padrao] : null;
                if (pageName) {
                    caminho = [{ path: pathname, titulo: pageName }];
                }
            }
        }
        return caminho;
    }

    function findPathByChave(tree, chave, path = []) {
        if (chave) {
            for (const node of tree) {
                // monta caminho parcial
                const newPath = [...path, node];

                // verifica se encontrou a rota
                let rota = removeBarrasIniciais(node.rota);
                let chaveSemBarras = removeBarrasIniciais(chave);
                if (rota === chaveSemBarras || (node.tipo === "GRUPO_SERVICOS" && `grupo/${rota}` === chaveSemBarras)) {
                    return newPath;
                }
                // verifica em subItens (ou outros nomes se tiver mais níveis)
                if (node.subItens) {
                    const found = findPathByChave(node.subItens, chave, newPath);
                    if (found) {
                        return found;
                    }
                }
            }
        }
        return null;
    }

    const verificaSeUrlCorrespondeAosPadroesSalvos = (url) => {
        let encontrado = [...padroesDePath].filter((padrao) => verificarPadraoUrl(url, padrao));
        return encontrado.length > 0 ? encontrado[0] : null;
    };

    const autofocus = () => {
        if (crumbAutofocus.current) {
            crumbAutofocus.current.focus({ focusVisible: true });
        }
    }

    const isRootLocation = () => {
        let rootPath = window.location.hash.split('?')[0];
        return rootPath === "#/"
    }

    const breadcrumbItems = useMemo(() => {
        let caminho = breadcrumbPaths.map(b => ({
            ...b,
            pathname: b.path || b.rota || b.pagePath,
            label: b.useTituloPagina && servicoSelecionado ? servicoSelecionado.nome : getServiceName(b) || b.label
        }));
        return caminho || [];
    }, [breadcrumbPaths])

    const handleClick = (item) => {
        if (item.tipo === "GRUPO_SERVICOS") {
            history.push(`/grupo/${removeBarrasIniciais(item.pathname)}`);
            return;
        }
        if (item.pathname.includes(":")) {
            //TODO Melhorar para quando houver :nb
            history.goBack();
            return;
        }
        history.push(item.pathname);
    }

    return (
        <>
            {autofocus()}
            {!isRootLocation() && breadcrumbPaths?.length> 0 &&
                <div className="govbr breadcrumb-desktop">
                    <nav className="br-breadcrumb" aria-label="Breadcrumbs">
                        <ol className="crumb-list" role="list">
                            <li className="crumb home">
                                <a className="br-button circle" onClick={(e) => {
                                    e.preventDefault();
                                    history.push("/");
                                }}>
                                    <span className="sr-only">Página inicial</span>
                                    <i className="fas fa-home"></i>
                                </a>
                            </li>
                            {breadcrumbItems?.map((item, index) => {
                                return (
                                    <li className="crumb" key={index} data-active={index === breadcrumbItems.length - 1 ? "active" : undefined}>
                                        {
                                            item.pathname && (
                                                <>
                                                    <i className="icon fas fa-chevron-right"></i>
                                                    {index === breadcrumbItems.length - 1 ? (
                                                        <span ref={crumbAutofocus} aria-current="page">{item.label}</span>
                                                    ) : (
                                                        <a
                                                            style={{ cursor: "pointer", fontSize: "inherit" }}
                                                            className="link-action"
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                handleClick(item);
                                                            }
                                                            }>
                                                            {item.label}
                                                        </a>
                                                    )}
                                                </>
                                            )
                                        }
                                    </li>
                                )
                            })}
                        </ol>
                    </nav>
                </div>
            }
        </>
    );
}

export default Breadcrumb;